import React from 'react';
import { useTranslation } from 'react-i18next';
import { dataFormatEnum } from '../../models-enums';
import { formatUnit } from '../../helpers/formatUnit';
import { formatTimestampWithTimezone } from '../../helpers/timezoneHelper';

export interface IReading {
    pointNumber: string;
    label: string;
    value: string;
    unit: number;
    format: string;
    status?: string;
    statusColor?: 'green' | 'red' | null;
}

interface ReadingsCardProps {
    readings: IReading[];
    updatedTimestamp?: string | null;
    srvRegionName?: string | null;
}

const ReadingsCard: React.FC<ReadingsCardProps> = ({
    readings,
    updatedTimestamp,
    srvRegionName
}) => {
    const { t } = useTranslation();

    if (!readings || readings.length === 0) {
        return (
            <div className="readings-card-empty">
                <p>No readings available</p>
            </div>
        );
    }

    return (
        <div className="readings-card">
            <div className="readings-card-header">
                <h3>Readings</h3>
                {updatedTimestamp && (
                    <p className="readings-card-updated">
                        Updated:{' '}
                        {formatTimestampWithTimezone(
                            updatedTimestamp,
                            srvRegionName
                        )}
                    </p>
                )}
            </div>
            <div className="readings-card-grid">
                {readings.map((reading, index) => (
                    <div key={index} className="reading-item">
                        <div className="reading-item-label">
                            {reading.label.toUpperCase()}
                        </div>
                        <div className="reading-item-value">
                            {t(
                                `common:format.${
                                    dataFormatEnum[
                                        dataFormatEnum.numberTruncate
                                    ]
                                }`,
                                {
                                    numberString: reading.value
                                }
                            )}
                            <span className="reading-item-unit">
                                {formatUnit(reading.unit)}
                            </span>
                        </div>
                        {reading.status && (
                            <div
                                className="reading-item-status"
                                style={
                                    reading.statusColor
                                        ? {
                                              backgroundColor:
                                                  reading.statusColor ===
                                                  'green'
                                                      ? '#4caf50'
                                                      : '#d20404',
                                              color: '#fff'
                                          }
                                        : undefined
                                }
                            >
                                {reading.status.toUpperCase()}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ReadingsCard;
